import {
  Route,
  Redirect,
} from 'react-router-dom';
import ROUTES from 'library/constants/routes';

function ProtectedRoute({ component: Component, ...restRouteProps }) {
  const auth = localStorage.getItem('colormylife-token');

  return (
    <Route
      {...restRouteProps}
      render={({ location, ...props }) => (auth ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: ROUTES.LOGIN,
            state: { from: location },
          }}
        />
      ))}
    />
  );
}

export default ProtectedRoute;
